import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { walldatas } from '../Config/exclusivehandwallcoveringdatas.js'; // Import the walldata
import Navbar from '../Components/Navbar.js';
import Footer from '../Components/Footer.js';
import Scrollfunctions from '../Components/Scrollfunctions.js';
import Shareooptions from '../Components/Shareooptions.js';
import TopSuggestions from '../Components/TopSuggestions.js';
import OurInformationhandpainting from '../Components/OurInformationhandpainting.js';
import { Undo2 } from 'lucide-react';
// import CertificateInfo from '../Components/CertificateInfo.js';
import Areyouanartistslide from "../Pages/areyouanartistslide.js"
import HandpaintingSlider from '../Pages/HandpaintingSlider.js';
import Collapsehandpaintings from '../Components/collapsehandpaintings.js';
import watermark from '../Images/watermark/WATERMARK-2.png';
import AddToWishlistButton from '../Components/AddToWishlistButton.js';

// Custom hook for managing meta tags
const useMetaTags = ({ title, description, image, url, type = 'website' }) => {
  useLayoutEffect(() => {
    // Update existing meta tags or create new ones
    const updateMetaTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Update title
    if (title) document.title = title;

    // Update Open Graph meta tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);

    // Update Twitter Card meta tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);

    // Update standard meta tags
    updateMetaTag('description', description);
  }, [title, description, image, url, type]);
};

const Exclusivehanddescs = () => {
  const { id } = useParams(); // Get the image ID from the URL
  const navigate = useNavigate(); // For navigating back
  // const location = useLocation();
  const imgRef = useRef(null); // Reference for the image
  // const isMobile = window.innerWidth <= 768;
  const [isWide, setIsWide] = useState(window.innerWidth >= 1077);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle browser back button and mobile back button navigation
  useEffect(() => {
    console.log('[exclusivehanddescs] Component mounted/updated with id:', id);
    
    // Store the current image ID when component mounts or id changes
    console.log('[exclusivehanddescs] Storing id in sessionStorage:', id);
    sessionStorage.setItem('lastViewedImageIdExclusivehandpainting', id);
    console.log('[exclusivehanddescs] sessionStorage now contains:', sessionStorage.getItem('lastViewedImageIdExclusivehandpainting'));

    const handleBeforeUnload = () => {
      // Store the current image ID in sessionStorage for back navigation
      console.log('[exclusivehanddescs] Before unload - storing id:', id);
      sessionStorage.setItem('lastViewedImageIdExclusivehandpainting', id);
    };

    // Add event listeners
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup: Store ID when component unmounts (e.g., when navigating away)
    return () => {
      console.log('[exclusivehanddescs] Component unmounting - storing id:', id);
      sessionStorage.setItem('lastViewedImageIdExclusivehandpainting', id);
      console.log('[exclusivehanddescs] After unmount, sessionStorage contains:', sessionStorage.getItem('lastViewedImageIdExclusivehandpainting'));
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [id]);

  useEffect(() => {
    const handleResize = () => {
      setIsWide(window.innerWidth >= 1077);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Find the image by EHP code instead of array index since the array is shuffled
  const selectedImage = walldatas.find(img => {
    const imgCodeNumber = parseInt(img.code.replace('#EHP', ''));
    return imgCodeNumber === parseInt(id);
  });

  // Set dynamic meta tags for social media sharing
  useMetaTags({
    title: selectedImage ? `${selectedImage.code} - ${selectedImage.series} | Exclusive Hand Painting | Vizaura` : 'Exclusive Hand Painting | Vizaura',
    description: selectedImage ? `${selectedImage.code} - ${selectedImage.series} by ${selectedImage.artist}. ${selectedImage.medium} on ${selectedImage.size}. Price: ₹${selectedImage.price}` : 'Discover exclusive hand paintings from Vizaura. Original artworks crafted with care and emotion.',
    image: selectedImage ? selectedImage.Img : 'https://vizaura.s3.eu-north-1.amazonaws.com/HandPainting/banners/1.jpg',
    url: window.location.href,
    type: 'website'
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle mousemove event for zoom effect
  const handleMouseMove = (e) => {
    const img = imgRef.current;
    const rect = img.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Limit transform origin to the container's edges to prevent white space
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    // Set the transform origin based on the percentage to ensure smooth zooming
    img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    img.style.transform = 'scale(1.5)'; // Adjust the zoom scale (e.g., 1.5 for less zoom)
  };

  // Reset zoom on mouse leave
  const handleMouseLeave = () => {
    const img = imgRef.current;
    img.style.transformOrigin = 'center';
    img.style.transform = 'scale(1)';
  };

  function useWindowWidth() {
    const [widths, setWidths] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidths(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return widths;
  }


  const widths = useWindowWidth();
  const isMobileOrTablet = widths <= 1023;


  // If no image is found (e.g., invalid ID), handle error
  if (!selectedImage) {
    return <div>Image not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto pt-20">
        {/* Back button */}
        <div className="mb-2 ml-2 sm:mb-6 sm:ml-5">
          <button
            onClick={() => {
              console.log('[exclusivehanddescs] Back button clicked - current id:', id);
              // Store the current ID before navigating (in case of refresh scenario)
              sessionStorage.setItem('lastViewedImageIdExclusivehandpainting', id);
              console.log('[exclusivehanddescs] Stored id in sessionStorage before navigation:', id);
              // Navigate with scrollTo parameter in URL
              const targetUrl = `/exclusivehandpaintings?scrollTo=${id}`;
              console.log('[exclusivehanddescs] Navigating to:', targetUrl);
              navigate(targetUrl);
            }}
            className="w-10 h-10 sm:w-14 sm:h-14 rounded-full bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 
       group hover:ring-2 hover:ring-gray-700 hover:ring-opacity-50 shadow-md hover:shadow-xl 
       flex items-center justify-center transition-all duration-300"
            aria-label="Go Back"
          >
            <Undo2 className="w-4 h-4 sm:w-6 sm:h-6 text-white group-hover:scale-110 transition-transform duration-300" />
          </button>
        </div>

        {/* Main content grid */}
        <div className={`grid grid-cols-1 lg:grid-cols-2 ${isWide ? 'gap-12' : 'gap-1'} mb-16 items-start`}>
          {/* Left side - Image */}
          <div className="relative overflow-hidden rounded-xl shadow-xl shadow-gray-400">
            {/* Watermark overlay: © + image */}
            <div className="absolute bottom-4 right-4 flex items-center space-x-2 z-10 pointer-events-none">
              <span className="text-lg lg:text-2xl text-gray-200" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.4)' }}>©</span>
              <img
                src={watermark}
                alt="Watermark"
                className="w-24 lg:w-48 select-none"
              />
            </div>

            {/* Main image */}
            <img
              ref={imgRef}
              src={selectedImage.Img}
              alt={selectedImage.title}
              className={
                isMobileOrTablet
                  ? "w-full h-auto object-cover transition-transform duration-300"
                  : "w-full h-auto object-contain transition-transform duration-300"
              }
              {...(!isMobileOrTablet && {
                onMouseMove: handleMouseMove,
                onMouseLeave: handleMouseLeave,
              })}
              style={{
                transition: 'transform 0.4s ease-out, transform-origin 0.4s ease-out',
              }}
              onError={(e) => {
                const el = e.currentTarget;
                if (el.src.endsWith('.jpg')) {
                  el.src = el.src.replace('.jpg', '.jpeg');
                }
              }}
            />
          </div>

          {/* Right side - Content */}
          <div className="flex flex-col h-full space-y-6">
            {/* Title, description, and context */}
            <div className="bg-white p-6 rounded-2xl shadow-lg relative">
              <div className="absolute top-4 right-4">
                <AddToWishlistButton item={{ ...selectedImage, title: selectedImage.code || selectedImage.title }} />
              </div>
              <h1 className="text-xl font-serif text-gray-600 mb-2 pr-12">{selectedImage.series}</h1>
              <p className="text-base text-gray-600 mb-4 leading-relaxed font-medium">{selectedImage.code}</p>


              <p className="text-gray-500 mb-2 font-serif"><span className="font-semibold font-serif">Size:</span> {selectedImage.size}</p>
              <p className="text-gray-500 mb-2 font-serif"><span className="font-semibold font-serif">Artist:</span> {selectedImage.artist}</p>
              <p className="text-gray-500 mb-2 font-serif"><span className="font-semibold font-serif">Medium:</span> {selectedImage.medium}</p>

              {/* Highlighted Price */}
              <p className="text-2xl font-bold text-gray-600 mb-4">
                ₹ {selectedImage.price}
              </p>
            </div>

            {/* Share options */}
            <div className="flex flex-col items-center py-8">
              <Shareooptions />
            </div>
            {/* < CertificateInfo /> */}
            <Collapsehandpaintings />
          </div>
        </div>
      </div>
      <HandpaintingSlider />
      <Areyouanartistslide />
      <OurInformationhandpainting />
      <TopSuggestions />
      <Scrollfunctions />
      <Footer />
    </div>
  );
};

export default Exclusivehanddescs;

